import { useNavigate, useParams, Link } from "react-router-dom";
import { api, getAuth, clearAuth } from "@/lib/api";
import { useVerifiedSession } from "@/lib/useVerifiedSession";
import AdminShell from "@/components/AdminShell";
import { LayoutGrid, Briefcase, ListTree, Users, CalendarCheck, MessageSquare, Palette, Settings, ExternalLink } from "lucide-react";

export default function TAdminLayout() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { status, data: tenant, retry } = useVerifiedSession(
    async () => {
      const auth = getAuth();
      if (!auth || auth.user.role !== "tenant_admin") return false;
      const r = await api.get("/tenant/me");
      // The signed-in admin must belong to the tenant in the URL.
      return r.data.tenant?.slug === slug ? r.data.tenant : false;
    },
    () => navigate(`/t/${slug}/admin/login`, { replace: true }),
    slug,
  );

  const logout = () => { clearAuth(); navigate(`/t/${slug}/admin/login`); };

  const nav = [
    { to: `/t/${slug}/admin`, icon: LayoutGrid, label: "Dashboard", end: true },
    { to: `/t/${slug}/admin/services`, icon: Briefcase, label: "Services" },
    { to: `/t/${slug}/admin/categories`, icon: ListTree, label: "Categories" },
    { to: `/t/${slug}/admin/sellers`, icon: Users, label: "Sellers" },
    { to: `/t/${slug}/admin/bookings`, icon: CalendarCheck, label: "Bookings" },
    { to: `/t/${slug}/admin/enquiries`, icon: MessageSquare, label: "Enquiries" },
    { to: `/t/${slug}/admin/branding`, icon: Palette, label: "Branding" },
    { to: `/t/${slug}/admin/profile`, icon: Settings, label: "Profile" },
  ].map((n) => ({ ...n, testid: `tadmin-nav-${n.label.toLowerCase()}` }));

  return (
    <AdminShell testid="tadmin-layout" overline={slug} title={tenant?.business_name || "Loading..."}
      subtitle={
        <Link to={`/t/${slug}`} target="_blank" className="text-[11px] text-neutral-500 hover:text-black inline-flex items-center gap-1 mt-2" data-testid="tadmin-open-pwa">
          Open customer app <ExternalLink className="h-3 w-3" />
        </Link>
      }
      nav={nav} onLogout={logout} logoutTestid="tadmin-logout" status={status} onRetry={retry} />
  );
}
